module.exports = __webpack_public_path__ + "img/36.e7d06a89.svg";